module.exports = __webpack_public_path__ + "img/001整体.212bd10c.png";